import type {
	NotificationApiResponse,
	NotificationTypeErrors,
} from '../../../../../../components/blackrock/advisor-center/_types/header.ts';
import { useEffect, useRef } from 'react';
import { createMainNavToast } from '../mainNavToaster.ts';
import { ToastTypes } from '../../../../../../components/blackrock/advisor-center/toast/model.ts';
import { removeUrlParamsFromUrl } from '../../../dashboard-navigation/helpers/updateUrlParams.tsx';

const NOTIFICATION_ID_QUERY_PARAM = 'acNoId';

const getNotificationIdFromUrl = () => {
	const searchParams = new URLSearchParams(window.location.search);

	return searchParams.get(NOTIFICATION_ID_QUERY_PARAM);
};

const removeNotificationIdFromUrl = () => {
	const newSearchParams = new URLSearchParams();

	newSearchParams.append(NOTIFICATION_ID_QUERY_PARAM, '');

	const newUrl = removeUrlParamsFromUrl(newSearchParams);

	history.replaceState(newUrl, newUrl, newUrl);
};

const logError = (message: string) => {
	console.error('Failed to create notification error toaster:', message);
};

const useNotificationErrorToaster = (
	notificationsResponse: NotificationApiResponse | null,
	typeErrors: NotificationTypeErrors | undefined
) => {
	const isInitializedRef = useRef(false);

	useEffect(() => {
		if (isInitializedRef.current) return;

		if (!notificationsResponse) {
			return;
		}

		isInitializedRef.current = true;

		const urlNotificationId = getNotificationIdFromUrl();

		if (!urlNotificationId) {
			return;
		}

		const notificationWithId = notificationsResponse.notifications.find(
			(elem) => elem.id === urlNotificationId
		);

		if (!notificationWithId) {
			logError('notification not found with id query param');
			return;
		}

		const isReferenceOnPage = !!document.querySelector(
			`#${notificationWithId.refId}`
		);

		if (isReferenceOnPage) {
			return;
		}

		const errorMessage = typeErrors?.[notificationWithId.type];

		if (!errorMessage) {
			logError(
				`no error message found for notification type ${notificationWithId.type}`
			);
			return;
		}

		createMainNavToast({
			type: ToastTypes.Error,
			label: errorMessage,
			ariaLabel: `Error toaster with message: ${errorMessage}`,
			closeButtonAriaLabel: 'close',
		});

		removeNotificationIdFromUrl();
	}, [notificationsResponse]);
};

export default useNotificationErrorToaster;
